import { EncodingValidationResponse, ProductionOrderRow } from 'core/api'
import { EncodingExtensions as Base } from 'core/extensions/EncodingExtensions'
import { EncodingOperationConfig } from 'core/shared/RemoteOperation'
import { __, T } from 'stylewhere/shared/i18n'

export class EncodingExtensions extends Base {
  static getProductionOrderFields = (_operation?: EncodingOperationConfig) => [
    { label: __(T.misc.production_order_row), path: 'code' }
  ]

  static getProductionOrderDetails = ({
    productionOrderRow
  }: {
    productionOrderRow?: ProductionOrderRow
    encodingValidationResponse?: EncodingValidationResponse
  }) => {
    return { subtitle: productionOrderRow?.productionOrder?.code, data: productionOrderRow }
  }
}
